import axios from 'axios';

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('vw_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;

  // Include Meta click/browser IDs only when the user has consented to marketing cookies
  if (localStorage.getItem('cookie_consent') === 'all') {
    const cookieMap = document.cookie.split(';').reduce((acc, c) => {
      const [k, v] = c.trim().split('=');
      if (k) acc[k.trim()] = v || '';
      return acc;
    }, {});
    if (cookieMap['_fbc']) config.headers['X-FB-FBC'] = cookieMap['_fbc'];
    if (cookieMap['_fbp']) config.headers['X-FB-FBP'] = cookieMap['_fbp'];
  }

  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('vw_token');
      localStorage.removeItem('vw_user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default api;
